import { cloneElement, isValidElement } from "react";

const _appendKeyToValidElement = (element, key) => {
  if (isValidElement(element) && element.key === null) {
    return cloneElement(element, { key });
  }
  return element;
};

export const generateTrackingDatastreamProperties = (
  data,
  streamProperties,
) => {
  return {
    ...streamProperties,
    ...(data.content_id && { content_id: data.content_id }),
    ...(data.content_type && { content_type: data.content_type }),
    ...(streamProperties?.oulipo_block_id && {
      oulipo_parent_block_id: streamProperties.oulipo_block_id,
    }),
    ...(typeof data.block_sibling_index !== "undefined" && {
      oulipo_block_sibling_index: data.block_sibling_index,
    }),
    ...(data.block_id && { oulipo_block_id: data.block_id }),
    ...(data.page_id && { oulipo_page_id: data.page_id }),
    ...(data.response_id && { oulipo_response_id: data.response_id }),
    ...(data.tracking_id && { oulipo_tracking_id: data.tracking_id }),
  };
};

export const renderChildren = ({
  members,
  hasHero,
  renderers,
  streamProperties,
  isStudent,
}) => {
  return members.map((member, index) => {
    return _appendKeyToValidElement(
      renderOulipoDataBlock({
        data: member,
        renderers,
        hasHero,
        index,
        streamProperties,
        isStudent,
      }),
      index,
    );
  });
};

export const renderOulipoDataBlock = ({
  data,
  renderers,
  hasHero,
  index,
  streamProperties,
  isStudent,
}) => {
  const { block_type: blockType, members } = data;
  const children = members
    ? renderChildren({
        members,
        renderers,
        hasHero,
        streamProperties: generateTrackingDatastreamProperties(
          data,
          streamProperties,
        ),
        isStudent,
      })
    : null;
  if (!blockType || !renderers[blockType]) {
    return children;
  }

  const renderingFunction = renderers[blockType];
  return renderingFunction({
    data,
    children,
    hasHero,
    index,
    streamProperties: generateTrackingDatastreamProperties(
      data,
      streamProperties,
    ),
    isStudent,
  });
};
